<template>
  <div>
    <portfolio></portfolio>
  </div>
</template>

<script>
import Portfolio from './Portfolio.vue'

export default {
  name: 'home',
  components: {
    portfolio: Portfolio
  }
}
</script>
